// Within this file we define constant identifiers for different client side routes within our application.

export const ClientRoutes = {
  //Auth
  LoginPage: "/login",
  LoginCallbackPage: "/login-callback",
  Logout: '/logout',

  //Admin
  SiteAdministrationSitesPage: "/home/siteadmin/sites",
  SiteAdministrationUsersPage: "/home/siteadmin/users",
  SuperAdministrationSitesPage: "/home/admin/sites",
  SuperAdministrationUsersPage: "/home/admin/users",
  SuperAdministrationDevicesPage: "/home/admin/managedevices",
  SuperAdministrationEndpointsPage: "/home/admin/manageendpoints",
  SuperAdministrationAssetTemplatesPage: "/home/admin/managetemplates",
  SuperAdministrationHeadUnitsPage: "/home/admin/manageheadunits",
  SuperAdministrationGatewaysPage: "/home/admin/managegateways",
  AuthToken: "/home/api/settings/auth-token",

  //Assets
  SiteSetupPage: "/home/sitesetup",
  SchedulePage: "/schedule",
  AreasPage: "/areas",
  AssetsPage: "/assets",
  DevicesPage: "/devices",
  PointsPage: "/points",
  ConsumablesPage: "/consumables",
  RouteEditorPage: "/routeeditor",
  EndpointsPage: "/endpoints",

  //Operations
  //Events Page
  EventsPage: "/home/events",

  //Actions Page
  ComplianceDashboardPage: '/home/dashboard-compliance',
  AssetsDashboardPage: '/home/dashboard-assets',
  HealthDashboardPage: '/home/dashboard-health',
  //backwards compatibility
  DashboardPage: '/home/dashboard',


  //Actions Page
  ActionsPage: '/home/actions',

  //Alets Page
  AlertsPage: "/home/alerts",

  //Sytem
  AlertsJobsPage: "/home/system/alertjobs",
  ComplianceReportJobsPage:  "/home/system/compliancereportjobs",
  DeviceJobsPage: "/home/system/devicejobs",
  NotificationJobsPage: "/home/system/notificationjobs",
  WorkOrderJobsPage: "/home/system/workorderjobs",
  WorkItemJobsPage: "/home/system/workitemjobs",
  //Notifications Page
  NotificationsPage: "/home/notifications",

  //Reports
  ComplianceReportPage: "/home/reports/compliancereport",
  PendingActionsPage: "/home/reports/pendingactions",
  EndpointReportPage: "/home/reports/endpointreport",
  PlanVsActualReportPage: "/home/reports/planvsactual",
  ReservoirsReportPage: "/home/reports/reservoirs",
  WorkOrdersReportPage: "/home/reports/workorders",
  ReportsPdfBuilderPage: "/home/reports/reportspdf",

  //TreeView Page
  SiteExplorerPage: "/home/siteexplorer",
  SiteExplorerPageWithId: "/home/siteexplorer/:id",
  SiteExplorerPageWithIdAndTabId: "/home/siteexplorer/:id/:tabId",

  //Schedule Page
  //Tasks Page

  //Other
  LoadingPage : "/loading",
  SupportPage: "/home/support",
  ProfilePage: "/profile",
  HomePage: "/",
  Home: '/home',
  DefaultPage: "/home/default",

};

export const  ReactQueryKeys = {
  AllSitesQuery: "sites",
  AllUsersQuery: "users",
  AllEventsQuery: "events",
  AllPointsEventsQuery: "pointsEvents",
  AllRolesQuery: "roles",
  AllAreasQuery: "areas",
  AllMachinesQuery: "machines",
  AllPointsQuery: "points",
  AllDevicesQuery: "devices",
  AllConsumablesQuery: "consumables",
  AllSchedulesQuery: "schedules",
  AllMaintenancePlansQuery: "maintenancePlans",
  MaintenancePlanOptionsQuery: "maintenancePlanOptions",
  WorkOrdersReportFiltersQuery: "workOrdersReportFilters",
  AllPointsWithPlansQuery: "pointsWithPlans",
  AllTasksQuery: "tasks",
  ManageDevicesQuery: "manageDevices",
  AllReportScheduleQuery: "complianceReport",
  AllTreeListQuery: "treelist",
  AllActivityChart: 'activityChart',
  AllActionsQuery: 'actions',
  ManageEndpointsQuery: 'manageEndpoints',
  ManageHeadUnitsQuery: 'manageHeadUnits',
  ManageGatewaysQuery: 'manageGateways',
  /** One account's registry, used with its site id: [key, siteId] */
  SiteHeadUnitsQuery: 'siteHeadUnits',
  SiteGatewaysQuery: 'siteGateways',
  AllEndpointsQuery: 'endpoints',
  AllEndpointEventsQuery: 'endpointEvents',
  AllFlowRateEventsQuery: 'flowRateEvents',
  AllTemperatureEventsQuery: 'temperatureEvents',
  AllGpsEventsQuery: 'gpsEvents',
  AllGreaseReservoirsQuery: 'greaseReservoirs',
  GreaseReservoirsAnalysisQuery: 'greaseReservoirsAnalysis',
  ManageAuthTokens: 'manageAuthTokens' ,
  EmailIntegrationsQuery: 'emailIntegrations',
  AllRequirementQuery: 'requirements',
  EndpointsLastSeenQuery: 'endpointsLastSeen',
  AllAlertsQuery: 'alerts',
  AllNotificationsQuery: 'notifications',
  AllNotificationsSummartQuery: 'notificationsSummary',
  AllEndpointsWithRequirementsQuery: 'endpointsWithRequirements',
  AllEndpointsWithPressureQuery: 'endpointsWithPressure',
  AllAlertJobsQuery: 'alertJobs',
  AllNotificatiosStatusQuery: 'notificationsStatus',
  AllStatusChartQuery: 'statusChart',
  AnalysisRequirementQuery: 'analysisRequirement',
  DashboardEndpointsMetricsQuery: 'dashboardEndpointsMetrics',
  DashboardManualComplianceQuery: 'dashboardManualCompliance',
  DashboardAutoComplianceQuery: 'dashboardAutoCompliance',
  DashboardTagsMetricsQuery: 'dashboardTagsMetrics',
  DashboardAlertsMetricsQuery: 'dashboardAlerts',
  SoftwareFeaturesQuery: 'softwareFeatures',
  AllCommsDevicesQuery: 'commsDevices',
  AllTemplatesQuery: 'templates',
  /** SuperAdmin: all templates across sites (Administration) */
  AllTemplatesQueryAll: 'templates-all',
  AllAssetImagesQuery: 'assetImages',
  AssetImageQuery: 'assetImage',
  SelectedTemplateQuery: 'selectedTemplate',
  UnmappedEndpointDevicesQuery: 'unmappedEndpointDevices',
  AllGatewaysQuery: 'allGateways',
  AllAssetsQuery: 'allAssets',
  SelectedAssetQuery: 'selectedAsset',
  AllAssetsMetricsQuery: 'allAssetsMetrics',
  AssetMetricsQuery: 'assetMetrics',
  AllTriggeredAlertsQuery: 'allTriggeredAlerts',
  AllHealthDashboardMetricsQuery: 'allHealthDashboardMetrics',
  DeviceInfoQuery: 'deviceInfo',
  AllDeviceFeaturesQuery: 'allDeviceFeatures',
  DeviceNotificationsChartQuery: 'deviceNotificationsChart',
  AlertsSettingsQuery: 'alertsSettings',
  /** Cause codes of one site - used with the site id: [CauseCodesQuery, siteId] */
  CauseCodesQuery: 'causeCodes',
  /** Site-wide endpoint list, used to resolve point names on the site Insights tab */
  SiteInsightsEndpointsQuery: 'siteInsightsEndpoints',
  /** Site-wide device list, used to resolve gateway serials on the site Insights tab */
  SiteInsightsDevicesQuery: 'siteInsightsDevices',
};
